import * as tslib_1 from "tslib";
import React from 'react';
import { connect } from 'formik';
/**
 * 表单值变化监听器
 */
var FormValueMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(FormValueMonitor, _super);
    function FormValueMonitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormValueMonitor.prototype.render = function () {
        if (this.props.action &&
            this.values &&
            this.props.formik.values !== this.values) {
            this.props.action(this.props.formik.values);
        }
        this.values = this.props.formik.values;
        return this.props.children ? this.props.children(this.values) : null;
    };
    return FormValueMonitor;
}(React.Component));
export default connect(FormValueMonitor);
//# sourceMappingURL=FormValueMonitor.js.map